/** @prettier */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { setGlobalBannerMessage } from '@xanadu/ui-shared/modules/application/actions';
import { displayModal } from '@xanadu/ui-shared/modules/modal/actions';
import {
  acceptTAndCChange,
  clearTermsFields,
} from '@xanadu/ui-shared/modules/termsAndConditions/actions';
import { loginRequest } from '@xanadu/ui-shared/modules/userSession/actions';

import Modal from '../../components/Modal';

const mapDispatchToProps = {
  setGlobalBannerMessage,
  displayModal,
  loginRequest,
  acceptTAndCChange,
  clearTermsFields,
};

function mapStateToProps(state) {
  return {
    config: state.get('modal'),
    placeholderImage: state.getIn(['application', 'loginImage']),
    terms: state.getIn(['termsAndConditions', 'termsAndConditions']),
    userTerms: state.getIn(['termsAndConditions', 'userTerms']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    userStatus: state.getIn(['user', 'status']),
    acceptError: state.getIn(['termsAndConditions', 'acceptError']),
    widthSize: state.getIn(['application', 'widthSize']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Modal));
